import { api, ApiRes } from './_api-client';
import { Folder } from './folders.service.tsx';
import { SubscriptionStatus, SubscriptionType } from './payment.service.ts';

export interface SignInReq {
  username: string;
  password: string;
}

export interface SendOtpReq {
  email: string;
}

export interface ResetPasswordReq extends SendOtpReq {
  otpCode: string;
  newPassword: string;
  confirmNewPassword: string;
}

export interface ActivateAccountReq extends SendOtpReq {
  userName: string;
  email: string;
  otpCode: string;
}

export interface SignInRes extends ApiRes {
  token: string | null;
  refreshToken: string | null;
}

export interface SignInForSSERes extends ApiRes {
  token: string;
}

export interface SignUpBody {
  userName: string;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  dob: string;
  rdoAccountType: '0' | '1'; // free | paid;
  source: string | null;
}

export interface UserInfo extends ApiRes {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  dob: string | null;
  userName: string;
  password: null;
  rdoAccountType: '1' | '0';
  isHelpMode: boolean;
  folders: Folder[];
  subscriptionType: SubscriptionType | null;
  subscriptionStatus: SubscriptionStatus | null;
}

export interface UserStorage {
  size: number;
  subscriptionId: number | null;
  subscriptionType: SubscriptionType | null;
  subscriptionStatus: SubscriptionStatus | null;
}

// S E R V I C E

export const signIn = async ({ username, password }: SignInReq) => {
  return api.post<SignInRes>('/Account/Login', { username, password });
};

export const reLogin = async (refreshToken: string) => {
  return api.post<SignInRes>('/Account/ReLogin', {}, { headers: { Refresh: refreshToken } });
};

export const signInForSSE = async () => {
  return api.post<SignInForSSERes>('/Account/LoginForSSE');
};

export const signUp = async (body: SignUpBody) => {
  return api.post<ApiRes>('/Account/SignUp', body);
};

export const resendSignUpOtpCode = async (body: SendOtpReq) => {
  return api.post<ApiRes>('/Account/ResendSignUpOtpCode', body);
};

export const activateAcc = async (body: ActivateAccountReq) => {
  return api.post<SignInRes>('/Account/ActivateAccount', body);
};

export const getUserInfo = () => {
  return api.get<UserInfo>('/Account/GetUserInfo');
};

export const getStorageSize = () => {
  return api.get<UserStorage>('/Account/GetStorageSize');
};

export const sendOtp = async (body: SendOtpReq) => {
  return api.post<ApiRes>('/Account/SendOtp', body);
};

export const resetPassword = async (body: ResetPasswordReq) => {
  return api.post<ApiRes>('/Account/ResetPassword', body);
};

export const updateHelpMode = async (isActive: boolean) => {
  return api.patch<ApiRes>(`/Account/UpdateHelpMode?isActive=${isActive}`);
};
